import { RefObject, useEffect } from 'react';

// Shared by every portal-rendered dropdown/menu (FilterDropdown, DropdownPortal,
// AuditLogsTableRow's severity menu, ...): closes the menu on an outside click,
// on scroll of anything other than the menu itself, and optionally on resize.
export function useCloseOnOutsideInteraction(
  isOpen: boolean,
  containerRefs: RefObject<HTMLElement | null>[],
  onClose: () => void,
  options: { closeOnResize?: boolean } = {}
) {
  const { closeOnResize = false } = options;

  useEffect(() => {
    if (!isOpen) return;

    function isInsideAny(target: Node) {
      return containerRefs.some((ref) => ref.current?.contains(target));
    }

    function handleClickOutside(event: MouseEvent) {
      if (!isInsideAny(event.target as Node)) {
        onClose();
      }
    }

    function handleScroll(event: Event) {
      if (isInsideAny(event.target as Node)) return;
      onClose();
    }

    function handleResize() {
      onClose();
    }

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('scroll', handleScroll, true);
    if (closeOnResize) window.addEventListener('resize', handleResize);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('scroll', handleScroll, true);
      if (closeOnResize) window.removeEventListener('resize', handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, closeOnResize]);
}
